<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <DataTableMain
          :datatable="table"
          :on-success="successAction"
          :itemsAction="tableAction"
        />
      </v-col>
      <v-col cols="12">
        <ViewDetails class="ma-5" :object="object" type="PreCalificacionCustomer" :itemsAction="tableAction"/>
      </v-col>
    </v-row>
    <PrecalificacionDialog :model="credit" v-if="get_dialogMain.dialog" />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import DataTableMain from '@/components/tables/DataTableMain'
import PrecalificacionDialog from '@/components/dialogs/PrecalificacionDialog'
import ViewDetails from '@/components/ViewDetails'
import { Permission } from '@/mixins/permissionMain'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      modelMain: [],
      showSelect: true,
      singleSelect: true,
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' }
        ],
        titles: [
          // { text: '', value: 'Actions', class: 'black--text' },
          { text: 'Nombre Completo', value: 'NombreCompleto', class: 'black--text' },
          { text: 'Telefono', value: 'telefono', class: 'black--text' },
          { text: 'Correo', value: 'correo', class: 'black--text' },
          { text: 'Estado Civil', value: 'estado_civil', class: 'black--text' },
          { text: 'Valor Vivienda', value: 'FieldDinamicData', class: 'black--text', action: 'FormatNumberMoney', field: 'customer_credit.precioVivienda' },
          { text: 'Tipo de Credito', value: 'customer_credit.tipoCredito', class: 'black--text' },
          { text: 'Activo', value: 'Activo', class: 'black--text' }
        ],
        losading: false
      },
      body: {
        data: [],
        actions: []
      },
      footer: {
        paging: true
      }
    },
    credit: {},
    id: 0
  }),
  components: {
    DataTableMain,
    ViewDetails,
    PrecalificacionDialog
  },
  mounted () {
    const user = this.$cookies.get('user')
    this.id = user.id
    this.PostListObjects({ url: '/clientes/precalificacion', data: { idUser: user.id } })
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['PostListObjects', 'getUrExporPdftDataServerAction']),
    successAction (item) {
      this[item.action](item)
    },
    refreshData (item) {
      this.table.header.loading = true
      this.PostListObjects({ url: '/clientes/precalificacion', data: { idUser: this.id } })
    },
    tableAction (item) {
      this[item.action](item.item)
    },
    toViewCredit (item) {
      this.credit = item
      this.SHOW_DIALOG_MAIN({ type: 'create' })
    },
    toDownloadView (item) {
      this.getUrExporPdftDataServerAction({ url: `clientes/credito/tipo-credito/pdf/${item.id}`, nombre: 'SimuladorCredito' })
    },

    ...mapMutations(['SHOW_DIALOG_MAIN'])
  },
  computed: {
    ...mapGetters(['get_objects', 'get_dialogMain', 'get_objectExport']),
    object () {
      if (this.table.modelMain.length > 0) {
        return this.table.modelMain[0]
      }
      return {}
    }
  },
  watch: {
    get_objects (vals) {
      if (vals) {
        this.table.header.loading = false
        this.table.modelMain = []
        if (vals.length > 0) {
          this.table.modelMain.push(vals[0])
        }
        this.table.body.data = vals
      }
    },
    get_objectExport (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error !',
          text: val.message
        })
        return
      }
      const linkSource = `data:application/pdf;base64,${val.pdf}`
      const downloadLink = document.createElement('a')
      downloadLink.href = linkSource
      downloadLink.download = val.nombre
      downloadLink.click()
    }
  }
}
</script>

<style></style>
